package utils

fun Long?.toBoolean(): Boolean {
    return this != null && this != 0L
}